import React, { Component } from "react";
import ReactEcharts from "echarts-for-react";
import helper from "../utils/helper"

class BaseChart extends Component {

    gerarResumos = (resumos = []) => (
        <div className="hdv-resumo-list">
            {resumos.map((resumo, index) => (
                <div className="hdv-resumo" key={index}>
                    <div><b>{resumo?.descricao}</b></div>
                    <div>
                        Min: {resumo?.valores?.primeiro_periodo?.min ?? 0} |
                        Med: {resumo?.valores?.primeiro_periodo?.med ?? 0} |
                        Max: {resumo?.valores?.primeiro_periodo?.max ?? 0}
                    </div>
                </div>
            ))}
        </div>
    );

    formatTooltip = (params, series) => {
        if (!Array.isArray(params)) return "";

        let formatted = "";

        params.forEach((param) => {
            let value = Array.isArray(param.data)
                ? param.data[1]
                : param.data;

            value = Number(value ?? 0).toFixed(2);

            const serie = series?.[param.seriesIndex];

            if (serie?.calcular_como === "horimetro") {
                value = helper.decimalToTime(Number(value));
            }

            formatted += `
                <div style="display:flex;align-items:center">
                    <div style="
                        background-color:${param.color};
                        height:14px;
                        width:14px;
                        border-radius:7px;
                        margin-right:5px">
                    </div>
                    ${param.seriesName}: <b>${value}</b>
                </div>
            `;
        });

        return formatted;
    };

    render() {
        const {
            id,
            tipo = "line",
            descricao,
            series = [],
            xAxis = null,
            legend = [],
            resumos = [],
            comparacao,
            compactMode = false,
            customOptions = {},
            chartStyle = { height: "400px" }
        } = this.props;

        const baseSeries = series.map(s => ({
            ...s,
            type: tipo,
            smooth: tipo === "line",
            barMaxWidth: tipo === "bar" ? 40 : undefined
        }));

        const baseOption = {
            series: baseSeries,
            xAxis: {
                type: "category",
                data: xAxis
            },
            yAxis: { type: "value" },
            legend: {
                data: legend,
                type: "scroll",
                show: !compactMode
            },
            tooltip: compactMode
                ? { show: false }
                : {
                    trigger: "axis",
                    formatter: (p) => this.formatTooltip(p, series)
                },
            dataZoom: compactMode
                ? []
                : [{ type: "inside" }, { bottom: 0 }]
        };

        const finalOption = {
            ...baseOption,
            ...customOptions,

            xAxis: {
                ...baseOption.xAxis,
                ...customOptions.xAxis
            },

            yAxis: {
                ...baseOption.yAxis,
                ...customOptions.yAxis
            },

            series: customOptions.series
                ? customOptions.series
                : baseOption.series
        };

        return (
            <div id={`chart-id-${id}`}>

                {!compactMode && <h5>{descricao}</h5>}

                {!compactMode && resumos.length > 0 && this.gerarResumos(resumos)}

                <ReactEcharts
                    style={chartStyle}
                    option={finalOption}
                />

                {!compactMode && comparacao && (
                    <div style={{ textAlign: "center", fontWeight: "bold" }}>
                        {comparacao?.geral?.texto}
                    </div>
                )}
            </div>
        );
    }
}

export default BaseChart;